import { render, staticRenderFns } from "./AlertListBaseEv.vue?vue&type=template&id=125192e9&scoped=true"
import script from "./AlertListBaseEv.vue?vue&type=script&lang=js"
export * from "./AlertListBaseEv.vue?vue&type=script&lang=js"
import style0 from "./AlertListBaseEv.vue?vue&type=style&index=0&id=125192e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125192e9",
  null
  
)

export default component.exports